import React, { useState } from 'react';
import Button from '../../components/Button/Button';
import Input from '../../components/Input/Input';
import Textarea from '../../components/Textarea/Textarea';
import Form from '../../components/Form/Form';
import Api from '../../services/Api/Api';
import { useErrorHandler } from '../../services/Utils/useErrorHandler';
import { useLoading } from '../../services/LoadingContext/LoadingContext';

const ShipEditForm = ({ onUpdate, ship }) => {
  const { id } = ship;
  const [name, setName] = useState(ship && ship.name);
  const [address, setAddress] = useState(ship && ship.address);
  const errorHandler = useErrorHandler();

  const handleSubmit = useLoading(async (e) => {
    e.preventDefault();
    try {
      await Api.UpdateShip({ id, name, address });
      onUpdate && onUpdate();
    } catch (e) {
      await errorHandler(e);
    }
  });

  return (
    <Form onSubmit={handleSubmit}>
      <Input
        title='Name'
        required
        minLength='3'
        defaultValue={name}
        onChange={(e) => setName(e.target.value)}
      />
      <Textarea
        title='Address'
        rows='5'
        required
        defaultValue={address}
        onChange={(e) => setAddress(e.target.value)}
      />
      <Button type='submit'>Save</Button>
    </Form>
  );
};

export default ShipEditForm;
